<template>
    <div
        class="d-flex align-center justify-center text-typography3"
        style="width: 100vw; height: 100vh"
    >
        <v-progress-circular indeterminate size="64" />
    </div>
</template>
